import * as preact from 'preact'
const { h, render } = preact
import domready from 'domready'
import { toArray, createUniqueId } from '@nrk/dh-utils'
import { createGoogleAnalyticsTracker } from '@nrk/dh-analytics-utils'
import { createErrorReporter } from '../lib/errorReporting'
import { getContextId } from '../lib/getContextId'
import { Provider as CustomProvider } from '../lib/provider'
import { App } from './components/App'
import * as styles from './components/App.css'
import { Listener, checkHasVhBug } from './lib/vh-fix/'
const rootElementClassName = styles.root
;(window as any)[rootElementClassName] = (window as any)[rootElementClassName] || {}

function init() {
  findElements(rootElementClassName).forEach((el: Element) => {
    el.id = createUniqueId()
    ;(window as any)[rootElementClassName][el.id] = true

    // Extract values sent from server
    const name = el.getAttribute('data-name')
    const preloadedState = el.getAttribute('data-preloaded-state')
    const preloadedStateJSON = preloadedState ? JSON.parse(preloadedState) : ''
    const errorTrackingEnabled = el.getAttribute('data-error-tracking-enabled') === 'true'

    // setup error reporting
    const simpleErrorReport = createErrorReporter(name ? name : '', errorTrackingEnabled)
    simpleErrorReport.listenAndCatch()

    // Extract metadata required to create google analytics tracker
    const gaPropertyId = el.getAttribute('data-ga-property-id')
    const metadata = el.getAttribute('data-metadata')
    const metadataJSON = metadata ? JSON.parse(metadata) : ''
    const { title, selfId, published } = metadataJSON

    // create google analytics tracker
    const googleAnalyticsTracker = createGoogleAnalyticsTracker({
      name: 'dh',
      gaPropertyId,
      self: {
        id: selfId,
        title,
        publishedDate: published ? new Date(published) : null
      },
      context: {
        id: getContextId(document && document.location ? document.location.href : '')
      }
    })

    const sendError = (message: string) => {
      simpleErrorReport.sendErrorReport({ message })
    }

    const sendGaEvent = (eventObj: {}) => {
      googleAnalyticsTracker.sendEvent({
        category: `dh-modul-${name}`,
        ...eventObj
      })
    }

    // ... and render with the exact same props as on server
    render(
      <CustomProvider sendGaEvent={sendGaEvent} sendError={sendError}>
        <App {...preloadedStateJSON} />
      </CustomProvider>,
      el,
      el.firstChild as Element
    )
    // Enable webpack hot-reloading
    if ((module as any).hot) {
      // Reload and re-render preact application
      ;(module as any).hot.accept('./client', () => {
        const { App } = require('./components/App')
        const { Provider: CustomProvider } = require('../lib/provider')
        render(
          <CustomProvider sendGaEvent={sendGaEvent} sendError={sendError}>
            <App {...preloadedStateJSON} />
          </CustomProvider>,
          el,
          el.firstChild as Element
        )
      })
    }
  })
  if (checkHasVhBug()) {
    const vhListener = new Listener()
    vhListener.listen(handleViewportUpdate)
  }
}

if (module.hot) {
  require('preact/debug')
}

function findElements(className: string) {
  return toArray(document.getElementsByClassName(className)).filter((el: Element) => !isInitialized(el, className))
}

function isInitialized(el: Element, className: string) {
  return el.id && (window as any)[className][el.id]
}

function handleViewportUpdate(vh: number) {
  try {
    const html = document.getElementsByTagName('html')[0]
    html.style.setProperty('--dh-vh', `${vh}px`)
  } catch (error) {
    console.error(error)
  }
}

domready(init)
